import * as io from 'io-ts';
import { Money } from './Money';

export const ScheduledPayment = io.type({
  id: io.string,
  dueDate: io.string,
  amount: Money,
  interest: Money,
  principal: Money,
});
export type ScheduledPayment = io.TypeOf<typeof ScheduledPayment>;

export type PaymentSchedulePlan = {
  installments: ScheduledPayment[];
};

// payment agreement from servicing API
export const PaymentAgreementSchedule = io.type({
  id: io.string,
  schedule: io.type({
    installments: io.array(ScheduledPayment),
  }),
  balanceSummary: io.type({
    totalInterestEstimate: Money,
  }),
});

export type PaymentAgreementSchedule = io.TypeOf<
  typeof PaymentAgreementSchedule
>;

export const PaymentAgreementResponse = io.type({
  paymentAgreement: PaymentAgreementSchedule,
});

export type PaymentAgreementResponse = io.TypeOf<
  typeof PaymentAgreementResponse
>;
